import { Injectable } from '@angular/core';
import { StaticIcons, StaticPopupIcons, StaticSnackbarIcons, SvgConstants } from '../utility/svg-constants';
import { StaticSvgIconProp } from '../models/dynamic.model';

@Injectable({
  providedIn: 'root'
})
export class SvgIconGenerationService {

  constructor() { }

  public generateStaticIcon(iconName: string, isFrom: string) {
    const iconData =
      isFrom === 'Popup'
        ? StaticPopupIcons.filter(val => val.name === iconName)
        : isFrom === 'Snackbar'
          ? StaticSnackbarIcons.filter(val => val.name === iconName)
          : StaticIcons.filter(val => val.name === iconName);
    let iconClassName;
    if (isFrom === 'Snackbar') {
      iconClassName = iconName + 'SnackbarIcon';
    } else if (isFrom === 'Popup') {
      iconClassName = iconName + 'PopupIcon';
    } else {
      iconClassName = iconName + 'Icon';
    }
    const pathArray = [];
    for (let i = 1; i <= iconData[0].totalPath; i++) {
      const name = iconData[0].totalPath > 1 ? iconName + i : iconName;
      pathArray.push(SvgConstants[name as keyof typeof SvgConstants]);
    }
    const staticSvgIcon: StaticSvgIconProp = {
      path: pathArray,
      iconClass: iconClassName,
      width: iconData[0].width,
      height: iconData[0].height,
      name: iconName,
      pathClass: iconName + 'Path',
      totalPath: iconData[0].totalPath,
    };
    return staticSvgIcon;
  }
}
